module.exports = __webpack_public_path__ + "img/logo dourada.9258e010.png";